<div class="main">

  <div class="row m-0" *ngIf="this.disableEditpage">
    <div class="col-12 registering_user">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <div class="registering_user_name">Welcome, {{employeeProfileInfo?.firstName}}</div>
          <div class="registering_user_info"><span>{{employeeProfileInfo?.grade}} |
              {{employeeProfileInfo?.designation}}</span>
           
            <span> | {{employeeProfileInfo?.employeeId}} | <span *ngIf='expYears > 0'>{{expYears}}
              Year(s)</span> <span *ngIf='expMonths > 0'> {{expMonths}} Month(s)</span> exp.</span>
          </div>
        </div>
        <div class="startnow_button">
          <button *ngIf="showeditbutton" (click)="handleNavigation()" class="cursor-pointer"><span
              class="d-inline-flex align-items-center fs-14">Start Now <i
                class="material-symbols-outlined ml-1 fs-18">arrow_forward</i></span></button>
          <!-- <ng-template #tipContent>
            <p class="m-0 tooltipdata" [innerHTML]="statusDescriptions[0]"></p>
          </ng-template> -->
        </div>
      </div>
      <div class="mt-3">
        <div class="registering_skills_info">Tell us about your <b>skillset!</b> </div>
        <div class="registering_skills_info_data">Help us equip you with the ability to meet the needs of our customers.
        </div>
      </div>
      <div class="registering_skills_notes mt-3">
        <ul class="">
          <li>Fill in your skill sets on which you have expertise, and successful implementation of multiple solutions
          </li>
          <li>Mark the vertical(s) on which you have exposure and implemented solutions in that vertical.</li>
          <li>Utilize this section to provide details about the certifications you have completed.</li>
        </ul>
      </div>
      <div class="floating_container">
        <img src="../../../../assets/images/dashboard/gliding_slides.svg">
      </div>
    </div>
  </div>
  <div class="row m-0 py-3 px-2" *ngIf="!this.disableEditpage">
    <div class="user-details col-12 col-md-6 px-0 p-3">
      <div class="user-icons d-inline-flex" *ngIf="!isManager || !isViewTeamDashboard">
        <button class="profile_icons" (click)="openDialog(employeeProfileInfo?.employeeId)">
          <div>View</div>
          <div class="material-symbols-outlined fs-14">visibility</div>
        </button>

        <button  class="ml-2 profile_icons" [matMenuTriggerFor]="menu" [disabled]="disableEditpage"
          (click)="handleNavigation()">
          <div>Edit</div>
          <div class="material-symbols-outlined fs-14">edit</div>
        </button>

        <!-- <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="naviagateToEmployeeDetails()"
            *ngFor="let competency of employeeProfileInfo?.competencyName">{{competency}}</button>
        </mat-menu> -->
        <!-- <ng-template #tipContent>
          <div class="m-0 tooltipdata" [innerHTML]="statusDescriptions[0]"></div>
        </ng-template> -->
      </div>
      <div class="userinfodiv">
        <div class="user-photo">
          <div class="photo">
            <img width="100%" height="100%" src="../../../assets/images/user_avtar.png" />
          </div>
        </div>
        <div class="user-info w-100 py-2">
          <div class="name">
            <span class="h5 fw-600 emp-name">{{employeeProfileInfo?.firstName}} {{employeeProfileInfo?.lastName}}</span>
            <span id="subtitle">{{employeeProfileInfo?.grade}} | {{employeeProfileInfo?.designation}}</span>
            <div *ngIf="!isManager || !isViewTeamDashboard" class="name">
              <span id="subtitle">{{employeeProfileInfo?.employeeId}} | <span *ngIf='expYears > 0'>{{expYears}}
                  Year(s)</span> <span *ngIf='expMonths > 0'> {{expMonths}} Month(s)</span> exp.</span>
            </div>
            <div *ngIf="isManager && isViewTeamDashboard" class="name">
              <div class="first_section ml-2">
                <span id="subtitle">Total Projects : {{totalProjects.length}}
                  <sup class="material-symbols-outlined fs-16 info" [ngbTooltip]="tipContent"
                    tooltipClass="custom_tooltip" placement="right">info</sup>
                </span>
                <ng-template #tipContent class="mytooltip custom_tooltip tooltip-inner">
                  <div class="m-0 tooltipdata" [innerHTML]="getTooltipTextProfile('projects')">
                  </div>
                </ng-template>
              </div>

              <div class="first_section ml-2">
                <span id="subtitle">My Reportees : {{empReporting}}
                  <sup class="material-symbols-outlined fs-16 info" [ngbTooltip]="tipContent1"
                    tooltipClass="custom_tooltip" placement="right">info</sup>
                </span>
                <ng-template #tipContent1 class="mytooltip custom_tooltip">
                  <div class="m-0 tooltipdata" [innerHTML]="getTooltipTextProfile('empReporting')">
                  </div>
                </ng-template>
              </div>

              <div class="first_section ml-2">
                <span id="subtitle">Billable Employees : {{billableEmps}}
                  <sup class="material-symbols-outlined fs-16 info" [ngbTooltip]="tipContent2"
                    tooltipClass="custom_tooltip" placement="right">info</sup>
                </span>
                <ng-template #tipContent2 class="mytooltip custom_tooltip">
                  <div class="m-0 tooltipdata" [innerHTML]="getTooltipTextProfile('billableEmps')">
                  </div>
                </ng-template>
              </div>

              <div class="first_section ml-2">
                <span id="subtitle">Shadow Employees : {{shadowEmps}}
                  <sup class="material-symbols-outlined fs-16 info" [ngbTooltip]="tipContent3"
                    tooltipClass="custom_tooltip" placement="right">info</sup>
                </span>
                <ng-template #tipContent3 class="mytooltip custom_tooltip">
                  <div class="m-0 tooltipdata" [innerHTML]="getTooltipTextProfile('shadowEmps')">
                  </div>
                </ng-template>
              </div>

            </div>
          </div>
          <div class="Status_resume_container" *ngIf="!isManager || !isViewTeamDashboard">
            <div *ngIf="employee && employeeProfileInfo" class="inpool">
              {{ isInPool ? 'In pool' : 'Billable' }}
            </div>
            <div class="d-flex align-items-center justify-content-between">
              <div class="resume"
                [title]="employee?.resume === null ? 'Please click on edit and upload your resume.' : ''"
                (mouseover)="hoveredResume = true" (mouseout)="hoveredResume = false">
                {{ resumeMessage }}
                <small *ngIf="resumeMessage === 'Profile Uploaded'">
                  <i class="material-icons fs-16" style="color:#08857C">check_circle</i>
                </small>
                <small *ngIf="resumeMessage === 'Profile Not Uploaded'">
                  <i class="material-icons fs-16" style="color:#FF0000">cancel</i>
                </small>
              </div>
              <div>
                <span class="mr-1 profileStatus" id="profileStatus" [style.background-color]="cardColor"
                  [style.color]="cardTextColor" [title]="getTooltipText(employeeProfileInfo?.employeeProfileStatus)">
                  {{ cardText }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>



    </div>
    <div class="courses col-12 col-md-6 p-0">
      <div class="step-container" [@slideInOut]="getAnimationState()">
        <div class="row m-0 p-3 align-content-center" *ngIf="stepcontainer === 1">
        <div class="certification_card col-6 bder-right pointer" id="rightandbottom"
          (click)="isManager && isViewTeamDashboard?teamCourseDetailsNavigate():goToAssignedToMe()">
          <div class="certfications_icon_container">
            <span class="material-symbols-outlined" style="color: #168AD9">
              menu_book
            </span>
          </div>
          <div class="playbtn">
            <span class="number"
              *ngIf="!isManager || !isViewTeamDashboard">{{completedProgramscount}}/{{totalProgramscount}}</span>
            <span class="number" *ngIf="isManager && isViewTeamDashboard">{{overallTeamCompletedPrograms ||
              0}}/{{overallTeamPrograms || 0}}</span>
            <span class="h5 text_space_wrap fw-500">Completed Training <br> Programs</span>
          </div>
        </div>
        <div class="certification_card col-6 pl-md-3 pointer" (click)="naviagateToEmployeeDetailsCertifications()">
          <div class="certfications_icon_container">
            <span class="material-symbols-outlined" style="color: #168AD9">
              workspace_premium
            </span>
          </div>
          <div class="playbtn">
            <span class="number" *ngIf="!isManager || !isViewTeamDashboard">{{completedCertificates}}</span>
            <span class="number" *ngIf="isManager && isViewTeamDashboard">{{teamCertificationCount}}</span>
            <span class="h5 text_space_wrap fw-500">Certifications</span>
          </div>

        </div>
        <div class="certification_card col-6 bder-top bder-right pointer" id="right"
          (click)="!isManager || !isViewTeamDashboard ? goToMyRequestsPage() : goToTeamRequestsPage()">
          <div class="certfications_icon_container">
            <span class="material-symbols-outlined" style="color: #168AD9"> hourglass_top </span>
          </div>
          <div class="playbtn">
            <span class="number" *ngIf="!isManager || !isViewTeamDashboard">{{programRequestsCount}}</span>
            <span class="number" *ngIf="isManager && isViewTeamDashboard">{{teamprogramRequestsCount}}</span>
            <span class="h5 text_space_wrap fw-500">Program&nbsp;Request <br>Pending</span>
          </div>
        </div>
        <div class="certification_card col-6 bder-top pl-md-3">
          <div class="certfications_icon_container">
            <span class="material-symbols-outlined" style="color: #168AD9"> military_tech
            </span>
          </div>
          <div class="playbtn">
            <span class="number">{{myBadges}}</span>
            <span class="h5 text_space_wrap fw-500">My Badges</span>
          </div>
        </div>
      </div>

        <div
          style="width: 100%;"
          class="row m-0 p-3 align-content-center"
          *ngIf="stepcontainer === 2"
        >
          <div
            class="certification_card col-6 bder-right pointer"
            id="rightandbottom"
            (click)="goToMentorMenteeDashboard()"
          >
            <div class="certfications_icon_container">
              <span class="material-symbols-outlined" style="color: #168AD9">
                school
              </span>
            </div>
            <div class="playbtn">
              <span class="number">
                {{mentorCount}}/{{menteeCount}}
              </span>
              <span class="h5 text_space_wrap fw-500">Mentor/Mentee <br> Count</span>
            </div>
          </div>
          <!-- Please use below div in case adding new options -->
          <div class="certification_card col-6 pl-md-3 pointer"></div>
          <div class="certification_card col-6 bder-top bder-right pointer" id="right"></div>
          <div class="certification_card col-6 bder-top pl-md-3"></div>
        </div>
      </div>
      <!-- navigation buttons -->
      <div
        class="d-flex"
        style="position: absolute; bottom: -12px; width: 100%; justify-content: center; gap: 15px;"
      >
        <button
          [disabled]="stepcontainer === 1"
          (click)="navigateBackward($event)"
          class="navigate-button pr-2"
        >
          <i
            class="fa fa-angle-left cursor-pointer"
            [class.disabled-button]="stepcontainer === 1"
          ></i>
        </button>
        <button
          [disabled]="stepcontainer === 2"
          (click)="navigateForward($event)"
          class="navigate-button"
        >
          <i
            class="fa fa-angle-right cursor-pointer"
            [class.disabled-button]="stepcontainer === 2"
          ></i>
        </button>
      </div>
    </div>
  </div>
</div>
